import { render } from "./LockerInstructions_1.vue?vue&type=template&id=6ef4b4a6"
import script from "./LockerInstructions_1.vue?vue&type=script&lang=js"
export * from "./LockerInstructions_1.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mac/Projects/webshop/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__